import { render, staticRenderFns } from "./c-receive-form.vue?vue&type=template&id=4b58d3e1&scoped=true"
import script from "./c-receive-form.vue?vue&type=script&lang=js"
export * from "./c-receive-form.vue?vue&type=script&lang=js"
import style0 from "./c-receive-form.vue?vue&type=style&index=0&id=4b58d3e1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b58d3e1",
  null
  
)

export default component.exports